<template>
  <div>
    <div class="parent-box">
      <p>
        注销帐号是不可恢复操作，一旦注销，你自愿承担其所
        可能的所有结果，该结果包括但不限于如下结果:
      </p>

      <h3 id="mid-h3">1.注销后，帐号将无法登录、无法找回:</h3>

      <p>
        账号无法登录App、游戏、及其他相关产品或服务；且账号无法找回。
        <br />
        您的实名信息、手机号、第三方账号等绑定关系将解除。
      </p>

      <h3 id="mid-h3">2.注销后，帐号信息将会清除或匿名化处理:</h3>

      <p>
        除按照相关法律规定应当保留一定期限的相关信息或数
        据外，该帐号内所有的数据、信息将会被删除或匿名化
        处理且无法找回。你发布的点赞、评论、帖子等数据内 容记录将被匿名化处理。
      </p>

      <h3 id="mid-h3">3.注销后，帐号的全部权益将无法找回:</h3>

      <p>
        账户内的虚拟货币（余额、积分、优惠券等；其他已开
        通会员服务（月卡等）将视为您自愿放弃且无法继续使 用。
      </p>

      <h3 id="mid-h3">
        *申请注销后，15天内未登录即可完成账号注销。<br />
        15天内登陆该账号即可解除注销申请。
      </h3>

      <van-button
        id="btn-submit"
        round
        block
        type="primary"
        color="#12CEC7"
        @click="onNext"
      >
        确认注销
      </van-button>

      <p @click="$router.back()">返回</p>
    </div>
  </div>
</template>

<script>
import { onActivated, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { accountCancel, passCancel } from "@/api/user";
import { Toast } from "vant";
import { getQueryString } from "@/utils/location";
export default {
  name: "newspage",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      username: getQueryString("username"),
      yzm: getQueryString("yzm"),
      uid: getQueryString("uid"),
      oldPwd: getQueryString("oldPwd"),
    });

    const onNext = () => {
      if (getQueryString("username")) {
        onYzmCancel();
      } else {
        onPwdCancel();
      }
    };

    onActivated(() => {
      state.username = getQueryString("username");
      state.yzm = getQueryString("yzm");
      state.uid = getQueryString("uid");
      state.oldPwd = getQueryString("oldPwd");
    });

    // 验证码注销
    const onYzmCancel = async () => {
      var fromdata = {
        mobile: state.username,
        yzm: state.yzm,
      };
      console.log(fromdata);

      accountCancel(fromdata).then((response) => {
        console.log(response.data);

        if (response.data.code == 1) {
          Toast("注销成功");
          router.push({
            path: "/newAccountCancel/AccountCancelResult",
            query: {
              isSuccess: "1",
            },
          });
        } else {
          Toast(response.data.msg);
          // reportResult('0')
          router.push({
            path: "/newAccountCancel/AccountCancelResult",
            query: {
              isSuccess: "0",
              failedText: response.data.msg,
            },
          });
        }
      });
    };

    const onPwdCancel = async () => {
      // console.log(state.oldPwd);

      const res = await passCancel({
        uid: state.uid,
        pass: state.oldPwd,
      });
      // console.log("密码注销返回的结果----------------", res);

      if (res.data.code == 1) {
        Toast("注销成功");
        router.push({
          path: "/newAccountCancel/AccountCancelResult",
          query: {
            isSuccess: "1",
          },
        });
      } else {
        Toast(res.data.msg);
        router.push({
          path: "/newAccountCancel/AccountCancelResult",
          query: {
            isSuccess: "0",
            failedText: res.data.msg,
          },
        });
      }
    };

    return {
      state,
      onNext,
      onYzmCancel,
      onPwdCancel,
    };
  },
};
</script>

<style scoped="scoped">
.parent-box {
  padding: 30px;
  height: 100vh;
  background-color: #f7f8fa;
}

.parent-box p {
  color: #333;
  margin-top: 4px;
}

.red-h3 {
  font-size: 32px;
  font-family: 苹方-简-中粗体, 苹方-简;
  font-weight: normal;
  color: #ff3939;
}

.parent-box ul {
  margin-top: 28px;
  margin-left: 30px;
}

.parent-box ul li {
  list-style: disc !important;
  font-weight: normal;
  color: #6b6b6b;
  font-size: 28px;
}

#mid-h3 {
  margin-top: 56px;
  color: #333;
}

#check-box {
  margin-top: 80px;
}

.parent-box:deep(.van-checkbox__label) {
  color: #2acbaf;
}

#btn-submit {
  margin-top: 60px;
}

.parent-box :nth-of-type(5) {
  width: 80px;
  font-size: 34px;
  color: #9e9e9e;
  margin: 0 auto;
  margin-top: 30px;
}
</style>
